import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { driverModule } from '../../../../../../modules/information/driver';
declare const Swal;

@Component({
  selector: 'app-viewemployees',
  templateUrl: './viewemployees.component.html',
  styleUrls: ['./viewemployees.component.css']
})
export class ViewemployeesComponent implements OnInit {
  public employeeExcelColumns = [
    { key: 'name', label: 'Employee Name', required: false, sampleValue: 'John Doe' },
    { key: 'empRefID', label: 'Employee ID', required: false, sampleValue: 'EMP001' },
    { key: 'email', label: 'Email', required: false, sampleValue: 'john.doe@company.com' },
    { key: 'dob', label: 'Date Of Birth', required: false, sampleValue: 'DD/MM/YYYY' },
    { key: 'bloodGroup', label: 'Blood Group', required: false, sampleValue: 'O+' },
    { key: 'gender', label: 'Gender', required: false, sampleValue: 'Male/Female/Other' },
    { key: 'mobile', label: 'Mobile', required: false, sampleValue: '9876543210' },
    { key: 'emergencyContact', label: 'Emergency Contact', required: false, sampleValue: '9876543211' },
    { key: 'projectmanagermail', label: 'Project Manager Mail', required: false, sampleValue: 'rao@groupten.com' },
    { key: 'transportType', label: 'Transport Type', required: false, sampleValue: 'Pickup/Drop/Both' },
    // { key: 'department', label: 'Department', required: true, sampleValue: 'Operations' },
    // { key: 'workLocation', label: 'Work Location', required: true, sampleValue: 'Head Office' },
    // { key: 'area', label: 'Area', required: true, sampleValue: 'HSR Layout' },
    { key: 'tripType', label: 'Trip Type', required: false, sampleValue: 'Login/Logout/Both' },
    { key: 'branch', label: 'Branch', required: false, sampleValue: 'Main Branch' },
    { key: 'shift', label: 'Shift', required: false, sampleValue: 'General' },
    // { key: 'address', label: 'Address', required: false, sampleValue: '12 MG Road' },
    // { key: 'city', label: 'City', required: false, sampleValue: 'Bengaluru' },
    // { key: 'state', label: 'State', required: false, sampleValue: 'Karnataka' },
    { key: 'country', label: 'Country', required: false, sampleValue: 'India' },
    // { key: 'pincode', label: 'Pincode', required: false, sampleValue: '560001' },
    // { key: 'location', label: 'Location', required: true, sampleValue: '12.9716,77.5946' },
  ];

  public toggleUploadVeh: boolean = false;
  public uploadedExcel: any;
  public datacount:any;
  public xlFileName: any = '';
  public enableFileName: boolean = false;

  public closeExlUploadAlert: boolean = true;
  public exlUploadPopup: boolean = true;
  public exlUploadRes: any;
  public exlUploadTable = [
    { key: 'name', display: 'Employee Name', width: '130px' },
    { key: 'empRefID', display: 'Employee ID', config: { isUppercase: true, }, width: '110px' },
    { key: 'email', display: 'Email', width: '130px' },
    {
      key: 'dob', display: 'Date Of Birth',
      config: {
        isDate: true,
        format: 'dd MMM YYYY'
      },
      width: '110px'
    },
    {
      key: 'bloodGroup', display: 'Blood-Group',
      config: {
        isUppercase: true
      },
      width: '130px'
    },
    { key: 'gender', display: 'Gender', width: '110px' },
    { key: 'mobile', display: 'Mobile', width: '110px' },
    { key: 'emergencyContact', display: 'Emergency Contact', width: '150px' },
    { key: 'workLocation', display: 'Work Location', width: '110px' },
    {
      key: 'branch', display: 'Branch',
      config: {
        isBranch: true,
      },
      width: '110px'
    },
    {
      key: 'shift', display: 'Shift',
      config: {
        isShift: true,
      },
      width: '110px'
    },
    { key: 'transportType', display: 'Transport Type', width: '130px' },
    { key: 'department', display: 'Department', width: '110px' },
    { key: 'address', display: 'Address', width: '110px' },
    { key: 'city', display: 'City', width: '110px' },
    { key: 'state', display: 'State', width: '110px' },
    { key: 'country', display: 'Country', width: '110px' },
    { key: 'pincode', display: 'Pincode', width: '80px' },
    { key: 'location', display: 'location', width: '110px' },
  ]

  generalSetting: boolean = false;
  constructor(
    public api: ApiService,
    public router: Router,
    public storage: StorageService,
    public location: Location,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public loader: LoaderService,
    public comservice:CommonServices,
    public excel: ExcelExportService

  ) {
    this.route.paramMap.subscribe(params => {
      this.orgID = params.get('orgID');
    });
    this.userData = this.storage.get('vendorViewData');
    
    let userInfo = this.storage.get('userInfo');
    if (userInfo?.general?.event == true)  this.generalSetting = true;
  }

  public driverInfo: any = driverModule;
  userData: any;
  public employeeInformation: any;
  orgID: string;
  vendorID: string;
  public values: any = [];
  public editForm: boolean;
  public filterTable: boolean = true;
  public tableShow: boolean = false;
  public cols = [
    { key: '#', display: '#' },
    { key: 'empRefID', display: 'Employee ID', 
    config: { isUppercase: true, },
    minWidth:'80px' ,
    headerConfig:{ isDefault: true}},

    { key: 'branch', display: 'Branch', 
    minWidth:'80px' ,
    headerConfig:{ isDefault: true}},

    { key: 'email',display:'Email',
    config: {
      isLowercase: true
    }, width: '130px'},
    { key: 'name', display: 'Employee name',minWidth:'100px' ,  headerConfig:{ isDefault: true}},
    {
      key: 'bloodGroup', display: 'Blood group',
      config: {
        isUppercase: true
      },minWidth:'65px',
      headerConfig:{ isDefault: true}
    },
    // { key: 'mobile', display: 'Mobile' },
    // {
    //   key: 'dob', display: 'DOB', config: {
    //     isDate: true,
    //     format: 'dd MMM YYYY'
    //   },minWidth:'90px',
    //   headerConfig:{ isDefault: true}
    // },
    { key: 'gender', display: 'Gender',minWidth:'50px' ,headerConfig:{ isDefault: true} },
    { key: 'pincode', display: 'Pincode', minWidth:'50px' ,headerConfig:{ isDefault: true} },
    { key: 'transportType', display: 'Transport type',minWidth:'75px' ,headerConfig:{ isDefault: true} },
    // { key: 'state', display: 'State',minWidth:'100px' },
    // { key: "city", display: "City" },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' },          
          { display: 'Send credential', color: 'primary', icon: 'Mail Outline' },
          { display: 'Delete', color: 'warn', icon: 'Delete' },
        ]
      },
      width:'132px',
    }
  ];
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }

  //Excel
  public excelData:any = {};
  public shiftData:any = {};
  public branchData:any = {};


  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';

  ngOnInit() {
    this.getBranchList([]);
      setTimeout(()=>{ this.getEmployeeList(); },1000);
  }


  
  submitted(e: any) {
    console.log(e);
  }
  getEmployeeList(page = 1, limit = 10, search?) {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      page: page,
      limit: limit,
    };
    if (search) obj['search'] = search;

    this.api.transportManagerEmployeeList(obj).then((res: any) => {
      
      if (res.status == 'success') {
       
        this.processTableData(res.data);
        this.processPagination(res, obj);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  processPagination(data, req) {
    this.tableShow = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.tableShow = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    this.datacount=total;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getEmployeeList(data.page, data.limit, this.searchInputValue);
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getEmployeeList(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getEmployeeList(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }
  capitalizeFirstLetter(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  processTableData(data) {
    
    this.tableShow = false;
    this.employeeInformation = data.map((emp) => {
      let obj = {
        name: emp.name,
        email:emp.email,
        bloodGroup: emp.bloodGroup,
        empRefID: emp.empRefID,
        branch:this.capitalizeFirstLetter(this.branchData[emp.branch]),
        // dob: emp.dob,
        // city: emp.city ?  emp.city : '',
        transportType:emp.transportType ?  emp.transportType : '',
        pincode:emp.pincode ?  emp.pincode : '',
        gender:emp.gender ?  emp.gender : '',
        // state: emp.state ? emp.state : '',
        employeeID: emp.employeeID,
      }
      return obj;
    });

    setTimeout(() => { this.tableShow = true; }, 100);
  }

  downloadTemplate() {
    const templateRow = [];
    const columnWidths = [];
    const headerCells = [];

    this.employeeExcelColumns.forEach((column, index) => {
      templateRow.push(column.sampleValue || '');
      columnWidths.push({ colNo: index + 1, width: Math.max(column.label.length + 4, 18) });
      headerCells.push({
        cell: `${String.fromCharCode(65 + index)}1`,
        value: column.required ? {
          richText: [
            { text: column.label, font: { bold: true, color: { argb: 'FF000000' } } },
            { text: ' *', font: { bold: true, color: { argb: 'FFFF0000' } } }
          ]
        } : column.label,
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD9D9D9' }
        },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        },
        alignment: {
          vertical: 'middle',
          horizontal: 'center'
        }
      });
    });

    this.excel.generateExcel({
      Template: {
        data: {
          data: [],
          columWith: columnWidths
        },
        customizedData: [
          {
            value: this.employeeExcelColumns.map((column) => column.label),
            cellConfig: {
              cells: headerCells
            }
          },
          {
            value: templateRow,
            border: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
          }
        ]
      }
    }, 'Employee_Template.xlsx');
  }

  uploadExcelFile() {
    document.getElementById('employeeExcelUpload').click();
  }

  uploadEmployee(event) {
    this.loader.show();
    this.xlFileName = event.target.files[0].name;
    this.enableFileName = true;
    let apiObj = {

    }
    let url = 'organization/excel/addEmployee';
    this.api.xlsxFileUpload(apiObj, url, 'employeeExcelUpload', (res: any) => {

      this.loader.hide();
      if ((res.responseJSON?.existsData && Object.keys(res.responseJSON.existsData).length > 0) || (res.responseJSON?.validationFails && Object.keys(res.responseJSON.validationFails).length>0) || (res.responseJSON?.missmatchedBranch && Object.keys(res.responseJSON.missmatchedBranch).length>0)) {
        this.exlUploadRes = res.responseJSON;
      
        this.closeExlUploadAlert = false;
      }
      else if (res.responseJSON?.status == 'success' && res.responseJSON?.message) {
        this.enableFileName = false;
        this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 5000);
        setTimeout(() => { this.getEmployeeList(1, this.paginationData.limit); }, 5000);
        
      }
      else if (res.responseJSON?.status == 'failure' ) {
        // this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 10000);
        this.swal.swalFunction('error',res.responseJSON.status,res.responseJSON?.message, 2000);
      }
      let doc: any = document.querySelector('#employeeExcelUpload');
      doc.value = '';
    });
  }

  onActionHandler(e: any) {
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/employee/edit-employee', e.data.employeeID]);

    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteEmployeeData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/employee/single-view-employee', e.data.employeeID]);
    }
    else if (e.action.display.toLowerCase() == 'send credential' ){  
      // Please confirm that   
    Swal.fire({
      title: 'Are you sure?',
      text: 'send the credentials to this employee!',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, send it!',
      cancelButtonText: 'Close'
    }).then((result) => {
      if (result.isConfirmed) {
        this.mailSentEmployee(e)
      }
    });
    }
  }
  mailSentEmployee(e?){
 console.log("eeeee",e)

 let obj={
  'empRefID' : e.data['empRefID'],
  'employeeID' :e.data['employeeID'],
  'name' : e.data['name']
 }

this.api.employeeSendMail(obj).then((res:any)=>{
 if(res.status == 'success'){
   this.swal.swalFunction(res.status, res.status, res.message, 2000);
 }     
});
  }
  deleteEmployeeData(e?) {

    const obj = {
      orgID: e.data.orgID,
      employeeID: e.data.employeeID,
    };
    this.api.transportManagerEmployeeDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data == undefined || res.data == '') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.tableShow = true;
          this.getEmployeeList(1, this.paginationData.limit, this.searchInputValue);
        }
      } else {
        if (res.data == undefined || res.data == '') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
        }else{
          this.empRouteRemovePopup(res.data);
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  empRouteRemovePopup(routes) {
    let fireContent = {
      title: 'Remove Employee from Assigned Route!',
      icon: 'warning',
    };
    if (routes.length > 0) {
      let htmlContent = '';
      for (let r = 0; r < routes.length ; r++) {
        if (routes[r].title) htmlContent += `<tr><td class="border-top-0">${r + 1} .</td><td class="border-top-0 text-left">${routes[r].title}</td></tr>`;
      }
      if (routes.length > 1) fireContent['title'] = 'Remove Employee from Assigned Routes!';
      fireContent['html'] = `<div class="row px-5"><div class="col-12 px-5" style="max-height:200px;overflow-y:auto;"><table class="table table-responsive table-sm">` + htmlContent + `</table></div></div>`;
      setTimeout(() => {
        Swal.fire(fireContent);
      }, 300);
    }
  }
  // getPage(v, v2) { }

  async downloadEmpExl(){
    let empDetails:any = await this.getEmployeeExlData().catch((e)=>{ console.log('error',e)});
    let shiftIDs = {};
    let branchIDs = {};
    empDetails.map((item)=>{
      shiftIDs[item.shift] = true;
      branchIDs[item.branch] = true;
    })
    await this.getBranchList(Object.keys(branchIDs));
    await this.getListShift(Object.keys(shiftIDs));
    setTimeout(()=>{
      this.exportToExcel(empDetails);
    },2000)
  }

  getEmployeeExlData(){
      //getTrackingData
      return new Promise(async (resolve, reject) => {
        let obj = {
          page:0,
          limit:100
        }
        let returnData:any = [], ping = 1, i = 0;
        while (ping) {
          obj['page'] = i + 1;
          i++;
          let res = await this.api.transportManagerEmployeeList(obj).catch((e) => { console.log("Get tracking data"); });
          if (res && res['status'] == 'success') {
            if (res['data'].length <= 0) ping = 0;
            else {
             
              returnData = [...returnData, ...res['data']];
            }
          }else ping = 0;
        }
        resolve(returnData);
      })
    }

    async exportToExcel(empData) {
      let headers:any = [];
      let data:any = [];
      this.excelData = {};
      let finalColumn = 'F2';
      //  console.log('list action sos data',this.listActionSosData);
     

      headers = ['S.No.', 'Employee ID', 'Employee Name', 'Email', 'Mobile', 'Work Location','Branch','Shift','Transport Type','Department','Address','City','State','Country','Pincode'];
      for(let i=0;i<empData.length;i++){
        let item = empData[i];
        let empItem = [
          i+1,
          item.empRefID,
          item.name ? item.name: '---',
          item.email ? item.email : '---',
          item.mobile ? item.mobile : '---',
          item.workLocation ? item.workLocation : '---',
          item.branch ? this.branchData[item.branch] : '---',
          item.shift ? this.shiftData[item.shift] : '---',
          item.transportType ? item.transportType : '---',
          item.department ? item.department : '---',
          item.address ? item.address : '---',
          item.city ? item.city : '---',
          item.state ? item.state :'---',
          item.country ? item.country : '---',
          // "address": "chennai",
          // "city": "Chennai",
          // "state": "Tamil Nadu",
          // "country": "India",
          item.pincode ? item.pincode : '---',
        ]
        data.push(empItem);
      }

      const excelInfo = {
        title: {
          title: `Employee Details`,
          font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
          mergeCells: `A1:${finalColumn}`,
        },
        header: {
          headers: headers,
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF00' },
            bgColor: { argb: 'FF0000FF' }
          },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        },
        data: {
          data: data,
          columWith: [
            { colNo: 1, width: 7 },
            { colNo: 2, width: 20 },
            { colNo: 3, width: 20 },
            { colNo: 4, width: 25 },
            { colNo: 5, width: 25 },
            { colNo: 6, width: 100 },
            { colNo: 7, width: 25 },
            { colNo: 8, width: 25 },]
        }
      };
      // console.log('excel information', excelInfo);
      if (this.excelData['Employee_Details'] == undefined) { this.excelData['Employee_Details'] = {}; }
      this.swal.swalFunction("Success","Success","Please check your downloads", 2000);
  
      this.excelData['Employee_Details'] = excelInfo;
  
      const chunk: any = await this.comservice.chunkObject(this.excelData, 50);
      for (let i = 0; i < chunk.length; i++) {
        this.excel.generateExcel(chunk[i], 'Employee_Details' + this.comservice.timestampToDate(new Date().getTime(),'DMY_H_M_S') + '.xlsx');
      }
      
     
  
      //this.excel.generateExcel(this.listActionSosData, `SOS_${this.activeTable}_` + new Date().getTime() + '.xlsx');
    }
    async getListShift(shift) {
      const obj = {};
      obj['shiftID'] = shift;
  
      await this.api.ListShift(obj).then((res: any) => {
        if (res.status == 'success') {
          res.data.map((item)=>{
            this.shiftData[item.shiftID] = item.shiftName;
          });
        }
      }).catch((err) => {
        console.log(err);
      });
  }
    //branch
    async getBranchList(branch) {
      const obj:any = {};
      if(branch.length>0)
      {
      obj['branchID'] = branch;
      }else{
        obj['orgID'] = this.storage.get('userInfo').orgID;
      }
      console.log('branch obj', obj);
      await this.api.transportManagerBranchList(obj).then((res: any) => {
        if (res.status == 'success') {
          res.data.map((item)=>{
            this.branchData[item.branchID] = item.branchName;
          });
        }
      }).catch((err) => {
        console.log(err);
      });
  }
}
